/* tslint:disable */
/* eslint-disable */
/**
 * Pall IoT Beer
 * IoT Beer Unified Api using Micro-services pattern <br/> <br/>  [Data Model](https://pall-corp.atlassian.net/wiki/spaces/IBD/pages/2059403265/Domain+Data+Model/) <br><br> [Application Design](https://pall-corp.atlassian.net/wiki/spaces/IBD/pages/2066612225/Application+Backend/) <br><br> [Pall Corporation Github](https://github.com/orgs/pallcorporation/dashboard/) <br><br> [Open API Specification - DEV - JSON](https://d382zc847wamcs.cloudfront.net/open-api.json) <br><br> [Open API Specification - DEV - YAML](https://d382zc847wamcs.cloudfront.net/open-api.yaml) <br><br> [Open API Specification - Integration - JSON](https://d1xykk5obgtp95.cloudfront.net/open-api.json) <br><br> [Open API Specification - Integration - YAML](https://d1xykk5obgtp95.cloudfront.net/open-api.yaml) <br><br> [Generate API Token - Link](https://github.com/mitchboulay/cognito-authentication/blob/main/README.md) <br><br> [Development Frontend - Link](https://dev.beeriot.pall.net/) <br><br> [Integration Frontend - Link](https://integration.beeriot.pall.net/)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: vladimir_khazin@pall.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfigurationParameters {
    apiKey?: string | Promise<string> | ((name: string) => string) | ((name: string) => Promise<string>);
    username?: string;
    password?: string;
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string) | ((name?: string, scopes?: string[]) => Promise<string>);
    basePath?: string;
    baseOptions?: any;
    formDataCtor?: new () => any;
}

export class Configuration {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    apiKey?: string | Promise<string> | ((name: string) => string) | ((name: string) => Promise<string>);
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    username?: string;
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    password?: string;
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    accessToken?: string | Promise<string> | ((name?: string, scopes?: string[]) => string) | ((name?: string, scopes?: string[]) => Promise<string>);
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    basePath?: string;
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    baseOptions?: any;
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    formDataCtor?: new () => any;

    constructor(param: ConfigurationParameters = {}) {
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }

    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    public isJsonMime(mime: string): boolean {
        const jsonMime: RegExp = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    }
}
